import Benzinger from './Benzinger';
import BenzingerChart from './Chart.jsx';
import BenzingerForm from './Form.jsx';
import BenzingerResults from './Results.jsx';

export default {
  Benzinger,
  BenzingerChart,
  BenzingerForm,
  BenzingerResults
};


// WEBPACK FOOTER //
// ./src/App/benzinger/index.js